import { Component } from '@angular/core';

interface SitemapItem {
  name: string;
  url: string;
  children?: SitemapItem[];
}

@Component({
  selector: 'sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.scss'],
  standalone: false,
})
export class SitemapComponent {
  sitemap: SitemapItem[] = [
    {
      name: 'Presentations',
      url: 'apps.editor.list',
      children: [
        {
          name: 'Add Presentation',
          url: 'apps.editor.create',
        },
      ],
    },
    {
      name: 'Schedules',
      url: 'apps.schedules.home',
      children: [
        {
          name: 'Add Schedule',
          url: 'apps.schedules.add',
        },
      ],
    },
    {
      name: 'Displays',
      url: 'apps.displays.home',
      children: [
        {
          name: 'Add Display',
          url: 'apps.displays.add',
        },
      ],
    },
    {
      name: 'Screen Sharing',
      url: 'apps.screen-sharing.home',
    },
    {
      name: 'Storage',
      url: 'apps.storage.home',
    },
    {
      name: 'Settings',
      url: 'apps.settings.home',
      children: [
        {
          name: 'Company Settings',
          url: 'apps.settings.company-details',
          children: [
            {
              name: 'Add Sub-Company',
              url: 'apps.company.add',
            },
          ],
        },
        {
          name: 'Company Users',
          url: 'apps.settings.user-list',
          children: [
            {
              name: 'Add User',
              url: 'apps.user.add',
            },
          ],
        },
        {
          name: 'SSO Settings',
          url: 'apps.settings.sso-settings',
        },
        {
          name: 'Integrations',
          url: 'apps.settings.integrations.list',
        },
        {
          name: 'Companies & Licenses',
          url: 'apps.settings.company-licenses',
        },
        {
          name: 'Account & Billing',
          url: 'apps.settings.billing.home',
        },
      ],
    },
    {
      name: 'Authentication',
      url: 'apps.auth.signin',
      children: [
        {
          name: 'Sign in',
          url: 'apps.auth.signin',
        },
        {
          name: 'Sign up',
          url: 'apps.auth.signup',
        },
        {
          name: 'Request password reset',
          url: 'apps.auth.requestpasswordreset',
        },
        {
          name: 'Provision',
          url: 'apps.auth.provision',
        },
      ],
    },
  ];
}
